// @ts-nocheck
(function() {
  'use strict';

  if (!window.megaMenuConfigSections) window.megaMenuConfigSections = {};
  if (!window.megaMenuBannerImageUrls) window.megaMenuBannerImageUrls = {};

  function hasMegaConfig(handle) {
    const searchHandle = String(handle || '').toLowerCase().trim();
    const sections = window.megaMenuConfigSections || {};
    for (const sid in sections) {
      const s = sections[sid];
      if (s && s.blocks && s.blocks.some(function(b) {
        const h = (b.settings && b.settings.menu_item_handle || '').toLowerCase().trim();
        return b.type === 'mega-menu-content' && h === searchHandle;
      })) return true;
    }
    return false;
  }

  function restoreAffordances() {
    const containers = document.querySelectorAll('[data-mega-menu-container][data-rendered="true"]');
    containers.forEach(function(container) {
      const listItem = container.closest('[data-menu-list-item]');
      if (!listItem) return;
      const link = listItem.querySelector('[data-menu-link]');
      if (!link) return;
      const submenuInner = container.closest('.menu-list__submenu-inner');
      if (submenuInner && submenuInner.id) link.setAttribute('aria-controls', submenuInner.id);
      link.setAttribute('aria-haspopup', 'true');
      // Don't collapse a panel the user is currently hovering.
      if (link.getAttribute('aria-expanded') !== 'true') {
        link.setAttribute('aria-expanded', 'false');
      }
    });
  }

  window.megaMenuRestoreAffordances = restoreAffordances;

  function setupObserver() {
    const menuList = document.querySelector('[data-menu-list]');
    if (menuList && !menuList._megaMenuObserved) {
      menuList._megaMenuObserved = true;
      const obs = new MutationObserver(restoreAffordances);
      obs.observe(menuList, { childList: true, subtree: true });
    }
  }

  window.megaMenuConfigOnSectionLoaded = function(sectionId) {
    window.dispatchEvent(new CustomEvent('megaMenuConfigReady', { detail: { sectionId: sectionId } }));
    restoreAffordances();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupObserver);
    } else {
      setupObserver();
    }
  };

  const queue = window.__megaMenuConfigQueue;
  if (queue && queue.length) {
    queue.forEach(function(item) {
      window.megaMenuConfigSections[item.sectionId] = item.config;
      for (const bid in item.bannerUrls) window.megaMenuBannerImageUrls[bid] = item.bannerUrls[bid];
      window.megaMenuConfigOnSectionLoaded(item.sectionId);
    });
    window.__megaMenuConfigQueue = [];
  }

  window.addEventListener('megaMenuConfigReady', restoreAffordances);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }
})();
